'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
require('../CardColumnWrapper/CardColumnWrapper.js');
require('../CardColumnWrapper/CardColumnWrapperImageWrap.js');
require('../CardColumnWrapper/CardColumnWrapperImage.js');
var CardColumnWrapperContent = require('../CardColumnWrapper/CardColumnWrapperContent.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Wraps the HighlightCard's content (header, body, footer)
 */

var HighlightCardContent = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default["default"].createElement(CardColumnWrapperContent.CardColumnWrapperContent, _extends__default["default"]({
    ref: ref
  }, props, {
    className: utils.cx('chakra-highlight-card__content', props.className)
  }));
});
HighlightCardContent.displayName = 'HighlightCardContent';
exports.HighlightCardContent = HighlightCardContent;